import MoveUpOutlinedIcon from "@mui/icons-material/MoveUpOutlined";
import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Modal, { CommonModalProps } from "..";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { GetSelectedItems, TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import AssetTreeView from "../../TreeView/TitleTreeView/asset-tree-view-2";
import { useAppSelector } from "../../../Redux/redux-store";

export type ModalMoveAssetDriveElementProps = {
  selectableObjectLayers?: ObjectLayer[];
  headObjectId: number;
  objectIdsToDisable: number[];
  objectIdsToHilight: number[];
  onMoveAssetClick: (selectedAssetId: number, closeModal: () => void, disableLoader: () => void) => void;
};

export type ModalMoveAssetDriveProps = CommonModalProps<ModalMoveAssetDriveElementProps>;

const ModalMoveAssetDrive = React.forwardRef<any, ModalMoveAssetDriveProps>((props, ref) => {
  const { closeModal, ...elementProps } = props;
  const { objectIdsToHilight, objectIdsToDisable, headObjectId, onMoveAssetClick } = elementProps;
  const { t } = useTranslation();

  const selectedItems = useAppSelector(GetSelectedItems(TreeContext.MoveDrive));

  const [showLoader, setShowLoader] = React.useState(false);

  const handleMoveAsset = React.useCallback(() => {
    if (selectedItems) {
      setShowLoader(true);
      onMoveAssetClick(selectedItems[0], closeModal, () => setShowLoader(false));
    }
  }, [selectedItems, onMoveAssetClick]);

  return (
    <Modal
      title={t("modal:title.moveAsset")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      height={900} // Todo: Might need to delete later
      footer={
        <Button
          variant="contained"
          color="primary"
          onClick={handleMoveAsset}
          startIcon={!showLoader && <MoveUpOutlinedIcon />}
          fullWidth
          disabled={selectedItems.length === 0 || showLoader}
        >
          {showLoader ? <CircularProgress size={20} thickness={5} color="secondary" /> : t("common:moveAssets")}
        </Button>
      }
    >
      <AssetTreeView
        rootObjectId={headObjectId}
        context={TreeContext.MoveDrive}
        disableNavigation
        multiselect={false}
        //   objectClassesToExclude={Object.values(ObjectClass).filter((x) => x !== ObjectClass.Drive)}
        //   objectTypesToExclude={Object.values(ObjectType).filter(
        //     (x) => ![ObjectType.Folder, ObjectType.Group, ObjectType.VirtualHead].includes(x)
        //   )}
        unselectableIds={objectIdsToDisable}
      />
    </Modal>
  );
});

export default ModalMoveAssetDrive;
